import React from 'react';
import { SnackbarProvider } from 'notistack';

import styles from './style';

function Notification(props) {
  // laisser le styles() sinon le css des component MUI sont KO
  // eslint-disable-next-line no-unused-vars
  const classes = styles();
  return (
    <SnackbarProvider
      // classes={{
      //   variantSuccess: classes.success,
      //   variantError: classes.error,
      //   variantWarning: classes.warning,
      //   variantInfo: classes.info
      // }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      maxSnack={3}
      hideIconVariant={false}
      {...props}
    />
  );
}

export default Notification;
